import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container, Col, Row } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { revisionService } from "libs/api/revisionService";
import { LESSON_ACTIVITY_TYPES, ROUTES } from "const";
import { getCurrentRevisor } from "store/actions";
import { MSelect } from "components/forms";

class ReviewHistoryLA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      rndKey: 0,
      payload: [],
      revisorId: null,
      academicYear: 0,
    };
  }

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },

      {
        id: "date",
        Header: "Data revisione",
        accessor: "date",
        Cell: ({ value }) => (value ? dateHelper.toITDate(value) : "-"),
      },
      {
        id: "aa",
        Header: "Anno accademico",
        accessor: "aa",
        Cell: ({ value }) => {
          if (!value) return "-";
          const endYear = value + 1;
          return `${value}/${endYear}`;
        },
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href = ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_DETAIL + "/" + value;
        },
      },
    ],
  };

  setAcademicYear = (_, value) => {
    this.setState({ academicYear: value }, () => {
      if (this.state.academicYear > 0) {
        this.loadRemote(this.state.revisorId);
      } else {
        this.setState({ payload: [] });
      }
    });
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props.match.params;

    const revisor = getCurrentRevisor(context);
    const revisorId = revisor?.id;

    if (revisorId) {
      this.setState({ revisorId });
    }
  }

  componentDidUpdate(prevProps) {
    const { activityType } = this.props.match.params;
    const { revisorId, academicYear } = this.state;

    if (prevProps.match.params.activityType !== activityType && academicYear > 0) {
      this.loadRemote(revisorId);
    }
  }

  loadRemote(revisorId) {
    this.setState({ loading: true });

    const { activityType, status } = this.props.match.params;
    const { academicYear } = this.state;

    const filter = {
      status,
      revisorId,
      lessonType: "training",
      activityType,
      academicYear,
    };

    revisionService
      .listAllLessonActivity(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          const itemsWithDate = {
            ...val,
            date: val.revision?.date || "",
          };
          items.push(itemsWithDate);
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
            loadingError: true,
          });
        }
      });
  }

  //--- ---

  render() {
    const { loading, academicYear, payload } = this.state;
    const { activityType } = this.props.match.params;

    return (
      <>
        <Row>
          <Col>
            <Title
              subtitle={
                activityType === LESSON_ACTIVITY_TYPES.ABILITAZIONI
                  ? "Percorsi Abilitanti"
                  : activityType === LESSON_ACTIVITY_TYPES.TFA_INDIRE
                    ? "TFA Indire"
                    : "TFA Classico"
              }
            >
              Storico Revisioni
            </Title>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <MSelect onChange={this.setAcademicYear} id="academicYear" payload={this.PAYLOAD_YEAR}></MSelect>
          </Col>
        </Row>

        <hr />

        <section className="my-5">
          <Container>
            {loading ? (
              <MnemoLoading />
            ) : (
              academicYear > 0 && (
                <>
                  <MTable key={this.state.rndKey} tableData={payload} tableConfig={this.tableConfig} />

                  {payload.length === 0 && (
                    <BoxDanger key="nrp-1" className="my-3">
                      <div className="small text-info">Non ci sono dati da mostrare in database per l'anno selezionato.</div>
                    </BoxDanger>
                  )}
                </>
              )
            )}
          </Container>
        </section>
      </>
    );
  }
}

export default withRouter(ReviewHistoryLA);
